import { FILE_MIME_TYPES } from '@gearbelt/global';

import docLogo from '@/assets/vectors/doc-generic.svg';
import otherLogo from '@/assets/vectors/other-generic.svg';
import pdfLogo from '@/assets/vectors/pdf-generic.svg';
import pngLogo from '@/assets/vectors/png-generic.svg';

export const getFileTypeIcon = (mimeType: string) => {
  const iconType = FILE_MIME_TYPES[mimeType as keyof typeof FILE_MIME_TYPES];

  switch (iconType) {
    case 'png':
    case 'jpg':
    case 'webp':
      return <img src={pngLogo} width={28} className="size-4" />;
    case 'doc':
    case 'docx':
      return <img src={docLogo} width={28} className="size-4" />;
    case 'pdf':
      return <img src={pdfLogo} width={24} className="size-4" />;
    default:
      return <img src={otherLogo} width={24} className="size-4" />;
  }
};
